import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../../../reduxService/hooks';
import { endpoint } from '../../../../pages';
import { IOpenButtonProps } from './IOpenButton';

const OpenButton = (props: IOpenButtonProps) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const inputFile = React.useRef<HTMLInputElement | null>(null);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [openModal, setOpenModal] = React.useState<boolean>(false);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const open = Boolean(anchorEl);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const navigate = useNavigate();

    const handleClick = () => {
        window.location.href = endpoint.home;
        //navigate(endpoint.home);
    };

    return (
        <>
            <button type="button" className={props.className} onClick={handleClick}>
                <i className="fa-solid fa-door-open" />
                {t('header_open_button')}
            </button>
        </>
    );
};

export default OpenButton;
